import { useCallback } from "react";
import type { CheckboxItem } from "interfaces/product/product.types";
import type React from "react";

type UseDownloadCheckboxes = {
  setData: React.Dispatch<React.SetStateAction<CheckboxItem[]>>;
  setExpandedAccordionIds: React.Dispatch<React.SetStateAction<string[]>>;
  itemsData: CheckboxItem[];
};

export const useDownloadModalCheckboxes = ({
  setData,
  setExpandedAccordionIds,
  itemsData,
}: UseDownloadCheckboxes) => {
  const handleUpdateAll = useCallback(
    (checked: boolean) => {
      setData((prevData) =>
        prevData.map((item) => {
          const newChecked = item.checkboxContent.length ? checked : false;
          const updatedSublist = item.checkboxContent.map((subItem) => ({
            ...subItem,
            checked: newChecked,
          }));

          return {
            ...item,
            checked: newChecked,
            checkboxContent: updatedSublist,
          };
        }),
      );
    },
    [setData],
  );

  const handleSelectAll = useCallback(() => {
    handleUpdateAll(true);
    setExpandedAccordionIds(itemsData.map((item) => item.id));
  }, [handleUpdateAll, itemsData, setExpandedAccordionIds]);

  const handleClearAll = useCallback(() => {
    handleUpdateAll(false);
    setExpandedAccordionIds(itemsData.map((item) => item.id));
  }, [handleUpdateAll, itemsData, setExpandedAccordionIds]);

  return {
    handleSelectAll,
    handleClearAll,
    handleUpdateAll,
  };
};
